var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'OrderDetails', query: { orderNumber: _vm.orderNumber, orderSource: _vm.orderSource, dealerCode: _vm.dealerCode, salesOrg: _vm.salesOrganization }}}},[_vm._v("\n  "+_vm._s(_vm.orderNumber)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }